import { createReducer, on } from '@ngrx/store';
import { startOf } from '@util/date';

import { changeFilter } from '../actions/revenue-filters.actions';

export const revenueFiltersKey = 'revenueFilters';

export interface RevenueFiltersState {
  startDate: Date;
  endDate: Date;
}

export const initialState: RevenueFiltersState = {
  startDate: startOf('month'),
  endDate: new Date()
};

const reducer = createReducer(
  initialState,
  on(changeFilter, (state, { startDate, endDate }) => ({ ...state, startDate, endDate }))
);

export function revenueFiltersReducer(state, action): RevenueFiltersState {
  return reducer(state, action);
}
